import './ValueDisplayReport.css';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import Loading from '../../loading/Loading';
import { stringToNumberLocale } from '../../../helpers/formatter';
import Tooltip from "../../toolTip/tooltip";

const { keys } = Object;

const ValueDisplayReport = ({
  title, width = 'auto', height = 'auto', data: {
    value, description, details = {},
  },
}) => {
  const isValue = ! (! value && value !== 0);

  return (
    <div className="ValueDisplayReport report"
      style={{
        height: `${height}px`,
        width: `${width}px`,
      }}
    >
      <h2>{t(title)}</h2>
        <Tooltip description={description}
                 id={t(title)}
        />
      <br />
      {! isValue ? <Loading size={40} />
        : (
          <div className="ValueDisplayContent">
            <div className="LeftValueDisplay">
              <span className={`${(value === t('unableToFetchData')) ? 'unable-to-fetch-data' : ''}`}>
                {(value === t('unableToFetchData')) ? t('unableToFetchData') : stringToNumberLocale(value)}</span>
            </div>
            <div className="RightValueDisplay">
              {keys(details)
                .map(key => (
                  <span className={`${(details[key] === t('unableToFetchData')) ? 'unable-to-fetch-data' : ''}`} key={key}>
                    {details[key] === t('unableToFetchData')
                      ? t('unableToFetchData')
                      : details[key] + ' ' +t(key)}
                  </span>
                ))}
            </div>
          </div>
        )
      }
    </div>
  );
};

export default connect()(ValueDisplayReport);
